import { Store } from '@ngrx/store';
import { pairwise } from 'rxjs/operators';

import { AppState } from 'app/types';

import { VideoRoomService } from '../services/video-room.service';
import { mediaSelectors } from '../state/media';

import { Track } from './track';

export class MyParticipant {
  private videoTrack?: Track;
  private audioTrack?: Track;

  public constructor(
    private sid: string,
    private service: VideoRoomService,
    private store: Store<AppState>,
  ) {
    this.store
      .select(mediaSelectors.isVideoEnabled)
      .pipe(pairwise())
      .subscribe(([prev, current]) => {
        // Notify track to send OutgoingMessageType
        const notify = true;
        if (prev !== current) {
          if (current) {
            this.videoTrack?.enable(notify);
          } else {
            this.videoTrack?.disable(notify);
          }
        }
      });
  }

  public cleanVideoTracks(): void {
    if (!this.videoTrack) {
      return;
    }
    const { track } = this.videoTrack;
    if (track) {
      track.stop();
      track.enabled = false;
    }
    this.videoTrack = undefined;
  }

  public cleanAudioTracks(): void {
    if (!this.audioTrack) {
      return;
    }
    const { track } = this.audioTrack;
    if (track) {
      track.stop();
      track.enabled = false;
    }
    this.audioTrack = undefined;
  }

  public setVideoTrack(track: MediaStreamTrack): void {
    this.videoTrack = new Track(track, this.sid, this.service);
  }

  public enableVideo(notify: boolean): void {
    this.videoTrack?.enable(notify);
  }

  public disableVideo(notify: boolean): void {
    this.videoTrack?.disable(notify);
  }

  public setAudioTrack(track: MediaStreamTrack): void {
    this.audioTrack = new Track(track, this.sid, this.service);
  }

  public enableAudio(notify: boolean): void {
    this.audioTrack?.enable(notify);
  }

  public disableAudio(notify: boolean): void {
    this.audioTrack?.disable(notify);
  }

  public destroy() {
    this.cleanAudioTracks();
    this.cleanVideoTracks();
  }
}
